
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1jGHE", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $aXWIB = parcelRequire("aXWIB");


var $jhwJP = parcelRequire("jhwJP");

const $a6c434ed432a8a0c$var$i18nBase = (0, $aXWIB.defineMessages)({
    teamPresenceTitle: {
        id: "content-state.team-presence.title",
        defaultMessage: "Avatars on published content"
    },
    teamPresenceDescription: {
        id: "content-state.team-presence.description",
        defaultMessage: "When turned on, viewers can see who else is viewing published pages and blog posts. <a>Learn more about avatar visibility</a>"
    },
    teamPresenceDisabledTooltip: {
        id: "content-state.team-presence.tooltip.disabled",
        defaultMessage: "Turned off by site admin"
    },
    enableContentStateTitle: {
        id: "content-state.enable.content.state.title",
        defaultMessage: "Content statuses"
    },
    enableContentStateBody: {
        id: "content-state.enable.content.state.body",
        defaultMessage: "Turn off to hide the ability to add a status when a page or blog post is created"
    },
    suggestedStateSuggestionsTitle: {
        id: "content-state.default.status.suggestions.title",
        defaultMessage: "Suggest statuses"
    },
    suggestedStateSuggestionsBody: {
        id: "content-state.default.status.suggestions.body",
        defaultMessage: "Decide what statuses are shown by default to users in this space."
    },
    suggestedStateSuggestionsBodyExpanded: {
        id: "content-state.default.status.suggestions.body.expanded",
        defaultMessage: "Decide what statuses are shown by default to users in this space."
    },
    restoreDefaults: {
        id: "content-state.default.status.suggestions.body.restore.default",
        defaultMessage: "Restore defaults"
    },
    allowCustomContentStatesTitle: {
        id: "content-state.allow.custom.content.states.title",
        defaultMessage: "Create custom statuses"
    },
    allowCustomContentStatesBody: {
        id: "content-state.allow.custom.content.states.body",
        defaultMessage: "Allow authors to create their own custom statuses"
    },
    roughDraft: {
        id: "content-state.default.status.rough.draft",
        defaultMessage: "Rough draft"
    },
    inProgress: {
        id: "content-state.default.status.in.progress",
        defaultMessage: "In progress"
    },
    readyForReview: {
        id: "content-state.default.status.ready.for.review",
        defaultMessage: "Ready for review"
    },
    verified: {
        id: "content-state.default.status.verified",
        defaultMessage: "Verified"
    },
    save: {
        id: "content-state.save.status.button.text",
        defaultMessage: "Save"
    },
    cancel: {
        id: "content-state.cancel.text",
        defaultMessage: "Cancel"
    },
    addContentStatePlaceholder: {
        id: "content-state.status.maker.add.status.placeholder.text",
        defaultMessage: "Add status"
    },
    createStatus: {
        id: "content-state.create.status.button.text",
        defaultMessage: "Create a status"
    },
    restoreDefaultSuggestions: {
        id: "content-state.restore.default.suggestions",
        defaultMessage: "Restore default suggestions"
    },
    confirm: {
        id: "content-state.restore.default.suggestions.confirm",
        defaultMessage: "Confirm"
    },
    flagTitle: {
        id: "content-state.space.admin.duplicate.status.flag.title",
        defaultMessage: "The status you created already exists"
    },
    flagDescription: {
        id: "content-state.space.admin.duplicate.status.flag.description",
        defaultMessage: "Statuses with the same text and color indicator are considered duplicates and aren\u2019t created."
    },
    remove: {
        id: "content-state.default.status.remove.tooltip",
        defaultMessage: "Remove"
    },
    moreInfoMessage: {
        id: "content-state.more.info.message",
        defaultMessage: "Removing a suggestion won\u2019t impact pages or posts where it was used."
    }
});
const $a6c434ed432a8a0c$var$i18nLiveDocs = (0, $aXWIB.defineMessages)({
    enableContentStateBody: {
        id: "content-state.enable.content.state.body.livedocs",
        defaultMessage: "Turn off to hide the ability to add a status when a page, live doc, or blog post is created"
    },
    moreInfoMessage: {
        id: "content-state.more.info.message.livedocs",
        defaultMessage: "Removing a suggestion won\u2019t impact pages, docs, or posts where it was used."
    }
});
const $a6c434ed432a8a0c$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($a6c434ed432a8a0c$var$i18nBase, $a6c434ed432a8a0c$var$i18nLiveDocs);
module.exports["i18n"] = $a6c434ed432a8a0c$export$a7357cdd1f0b0168;

});

parcelRegister("5tbZ4", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $eXmBZ = parcelRequire("eXmBZ");


var $82gXq = parcelRequire("82gXq");


var $3gadb = parcelRequire("3gadb");




/**
 * @generated SignedSource<<857af7b6e43e29ea4e29292f350aec10>>
 * @relayHash 902035768e588acb4affaf8b9ad79cde
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bc54d3f8868f1f08b1400903f08eba41397e00e0be698e1b1c6d08a9762a3b9e
const $c699dba3f21a17c8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "ContentStateSettings",
            "kind": "LinkedField",
            "name": "resetSpaceContentStates",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "contentStatesAllowed"
                },
                {
                    "kind": "ScalarField",
                    "name": "spaceContentStatesAllowed"
                },
                {
                    "kind": "ScalarField",
                    "name": "customContentStatesAllowed"
                },
                {
                    "concreteType": "ContentState",
                    "kind": "LinkedField",
                    "name": "spaceContentStates",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "color"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "restrictionLevel"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "RestoreDefaultsTextButtonResetSpaceContentStatesMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "RestoreDefaultsTextButtonResetSpaceContentStatesMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "902035768e588acb4affaf8b9ad79cde",
            "id": "bc54d3f8868f1f08b1400903f08eba41397e00e0be698e1b1c6d08a9762a3b9e",
            "metadata": {},
            "name": "RestoreDefaultsTextButtonResetSpaceContentStatesMutation",
            "operationKind": "mutation",
            "text": "mutation RestoreDefaultsTextButtonResetSpaceContentStatesMutation($spaceKey:String!){resetSpaceContentStates(spaceKey:$spaceKey){contentStatesAllowed,spaceContentStatesAllowed,customContentStatesAllowed,spaceContentStates{name,color,id,restrictionLevel}}}"
        }
    };
}();
$c699dba3f21a17c8$var$node.hash = "7681abf1946dae8411518bf0ff51e43d";
var $c699dba3f21a17c8$export$2e2bcd8739ae039 = $c699dba3f21a17c8$var$node;

















var $inPa6 = parcelRequire("inPa6");


var $eEA8O = parcelRequire("eEA8O");


var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");


var $lsxnT = parcelRequire("lsxnT");


var $308Wd = parcelRequire("308Wd");


var $Uu0Pb = parcelRequire("Uu0Pb");


var $4S6vT = parcelRequire("4S6vT");


var $1jGHE = parcelRequire("1jGHE");

const $200ace427a1c11f6$var$UnderlinedBodyTextWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8wadc _4bfu1r31 _1hms8stv _ajmmnqa1 _syazazsu _80omtlke",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $200ace427a1c11f6$var$FooterButtonsWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _1bahesu3",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $200ace427a1c11f6$var$ContentStateWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _otyrv47k",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $200ace427a1c11f6$var$CircleWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _2hwxv47k",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $200ace427a1c11f6$var$restoreDefaultButtonWrapperStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.025'
});
const $200ace427a1c11f6$var$RestoreDefaultsTextButtonComponent = (t0)=>{
    const $ = (0, $frIzR.c)(47);
    const { spaceKey: spaceKey, underlinedBodyText: underlinedBodyText, originalSuggestedStatesArray: originalSuggestedStatesArray, setSuggestedStatesArray: setSuggestedStatesArray, intl: t1 } = t0;
    const { formatMessage: formatMessage } = t1;
    let t2;
    if ($[0] !== setSuggestedStatesArray) {
        t2 = {
            onCompleted: (data)=>{
                setSuggestedStatesArray([
                    ...data?.resetSpaceContentStates?.spaceContentStates || []
                ].map($200ace427a1c11f6$var$_temp));
            }
        };
        $[0] = setSuggestedStatesArray;
        $[1] = t2;
    } else t2 = $[1];
    const [restoreDefaultStatesMutation] = (0, $308Wd.useMutationInterop)((0, $c699dba3f21a17c8$export$2e2bcd8739ae039), {
        ...t2,
        __callerPackage__: "@confluence/content-state"
    });
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t3;
    if ($[2] !== formatMessage) {
        t3 = formatMessage((0, $1jGHE.i18n).roughDraft);
        $[2] = formatMessage;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t3) {
        t4 = {
            color: (0, $Uu0Pb.PRIMARY_COLORS).YELLOW,
            name: t3,
            restrictionLevel: "NONE"
        };
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    const roughDraft = t4;
    let t5;
    if ($[6] !== formatMessage) {
        t5 = formatMessage((0, $1jGHE.i18n).inProgress);
        $[6] = formatMessage;
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== t5) {
        t6 = {
            color: (0, $Uu0Pb.PRIMARY_COLORS).BLUE,
            name: t5,
            restrictionLevel: "NONE"
        };
        $[8] = t5;
        $[9] = t6;
    } else t6 = $[9];
    const inProgress = t6;
    let t7;
    if ($[10] !== formatMessage) {
        t7 = formatMessage((0, $1jGHE.i18n).readyForReview);
        $[10] = formatMessage;
        $[11] = t7;
    } else t7 = $[11];
    let t8;
    if ($[12] !== t7) {
        t8 = {
            color: (0, $Uu0Pb.PRIMARY_COLORS).GREEN,
            name: t7,
            restrictionLevel: "NONE"
        };
        $[12] = t7;
        $[13] = t8;
    } else t8 = $[13];
    const readyForReview = t8;
    let t9;
    if ($[14] !== formatMessage) {
        t9 = formatMessage((0, $1jGHE.i18n).verified);
        $[14] = formatMessage;
        $[15] = t9;
    } else t9 = $[15];
    let t10;
    if ($[16] !== t9) {
        t10 = {
            color: (0, $Uu0Pb.PRIMARY_COLORS).VERIFIED,
            name: t9,
            restrictionLevel: "PAGE_OWNER"
        };
        $[16] = t9;
        $[17] = t10;
    } else t10 = $[17];
    const verified = t10;
    let t11;
    if ($[18] !== inProgress || $[19] !== readyForReview || $[20] !== roughDraft || $[21] !== verified) {
        const defaultStatesArray = [
            roughDraft,
            inProgress,
            readyForReview,
            verified
        ];
        t11 = defaultStatesArray.map($200ace427a1c11f6$var$_temp2);
        $[18] = inProgress;
        $[19] = readyForReview;
        $[20] = roughDraft;
        $[21] = verified;
        $[22] = t11;
    } else t11 = $[22];
    const defaultStates = t11;
    let t12;
    if ($[23] !== createAnalyticsEvent || $[24] !== spaceKey) {
        t12 = ()=>{
            setIsModalOpen(true);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "text",
                    objectId: spaceKey,
                    actionSubjectId: "adminClickedRestoreDefaultsText",
                    source: "contentStateAdminSettings"
                }
            }).fire();
        };
        $[23] = createAnalyticsEvent;
        $[24] = spaceKey;
        $[25] = t12;
    } else t12 = $[25];
    const onClickRestoreDefaultsText = t12;
    let t13;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = ()=>{
            setIsModalOpen(false);
        };
        $[26] = t13;
    } else t13 = $[26];
    const closeModal = t13;
    let t14;
    if ($[27] !== createAnalyticsEvent || $[28] !== originalSuggestedStatesArray || $[29] !== restoreDefaultStatesMutation || $[30] !== setSuggestedStatesArray || $[31] !== spaceKey) {
        t14 = ()=>{
            restoreDefaultStatesMutation({
                variables: {
                    spaceKey: spaceKey
                }
            });
            setSuggestedStatesArray(originalSuggestedStatesArray);
            closeModal();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    objectId: spaceKey,
                    actionSubjectId: "adminConfirmedRestoreDefaults",
                    source: "contentStateAdminSettings"
                }
            }).fire();
        };
        $[27] = createAnalyticsEvent;
        $[28] = originalSuggestedStatesArray;
        $[29] = restoreDefaultStatesMutation;
        $[30] = setSuggestedStatesArray;
        $[31] = spaceKey;
        $[32] = t14;
    } else t14 = $[32];
    const restoreDefaults = t14;
    let t15;
    if ($[33] !== onClickRestoreDefaultsText || $[34] !== underlinedBodyText) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($200ace427a1c11f6$var$UnderlinedBodyTextWrapper, {
            onClick: onClickRestoreDefaultsText,
            "data-testid": "restore-defaults-button"
        }, underlinedBodyText);
        $[33] = onClickRestoreDefaultsText;
        $[34] = underlinedBodyText;
        $[35] = t15;
    } else t15 = $[35];
    let t16;
    if ($[36] !== Modal || $[37] !== defaultStates || $[38] !== formatMessage || $[39] !== isModalOpen || $[40] !== restoreDefaults) {
        t16 = isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
            testId: "restore-defaults-modal",
            onClose: closeModal,
            width: "small",
            messageType: "transactional",
            messageId: "content-state-restore-defaults-modal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
            hasCloseButton: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, formatMessage((0, $1jGHE.i18n).restoreDefaultSuggestions))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, defaultStates), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8o1lj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($200ace427a1c11f6$var$FooterButtonsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            testId: "cancel-button",
            appearance: "subtle",
            onClick: closeModal,
            style: {
                marginRight: "var(--ds-space-100, 8px)"
            }
        }, formatMessage((0, $1jGHE.i18n).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            testId: "confirm-button",
            appearance: "primary",
            onClick: restoreDefaults,
            style: {
                marginRight: "var(--ds-space-250, 20px)"
            }
        }, formatMessage((0, $1jGHE.i18n).confirm)))));
        $[36] = Modal;
        $[37] = defaultStates;
        $[38] = formatMessage;
        $[39] = isModalOpen;
        $[40] = restoreDefaults;
        $[41] = t16;
    } else t16 = $[41];
    let t17;
    if ($[42] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, t16);
        $[42] = t16;
        $[43] = t17;
    } else t17 = $[43];
    let t18;
    if ($[44] !== t15 || $[45] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $200ace427a1c11f6$var$restoreDefaultButtonWrapperStyles
        }, t15, t17);
        $[44] = t15;
        $[45] = t17;
        $[46] = t18;
    } else t18 = $[46];
    return t18;
};
const $200ace427a1c11f6$export$ea56b2bbb6a884a9 = (0, $aXWIB.injectIntl)($200ace427a1c11f6$var$RestoreDefaultsTextButtonComponent);
function $200ace427a1c11f6$var$_temp(s) {
    return s ?? null;
}
function $200ace427a1c11f6$var$_temp2(state) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($200ace427a1c11f6$var$ContentStateWrapper, {
        key: state.name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($200ace427a1c11f6$var$CircleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4S6vT.ContentStateColor), {
        dataTestId: "color-circle",
        appearance: "restoreContentStatesModal",
        color: state.color,
        restrictionLevel: state.restrictionLevel
    })), state.name);
}





const $23e341bfb9b0a98b$var$toggleSectionStyles = (0, $ecnYn.xcss)({
    marginBottom: 'space.500'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $23e341bfb9b0a98b$var$HeadingWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $23e341bfb9b0a98b$var$TitleTextWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8fhey _syazi7uo _k48p1wq8 _2hwxu2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $23e341bfb9b0a98b$var$toggleWrapperStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.negative.025'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $23e341bfb9b0a98b$var$BodyTextWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8wadc _1e0c1txw _syazazsu _k48p1wq8 _otyru2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $23e341bfb9b0a98b$var$infoIconWrapperStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.050'
});
const $23e341bfb9b0a98b$export$f8b39935006ae1af = (0, $aXWIB.injectIntl)(({ spaceKey: spaceKey, testId: testId, titleText: titleText, bodyText: bodyText, underlinedBodyText: underlinedBodyText, isChecked: isChecked, isToggleDisabled: isToggleDisabled, disabledTooltip: disabledTooltip, originalSuggestedStatesArray: originalSuggestedStatesArray, setSuggestedStatesArray: setSuggestedStatesArray, onToggleClick: onToggleClick, showRestoreDefaults: showRestoreDefaults, intl: { formatMessage: formatMessage } })=>{
    const isSuggestStatusesSection = !!underlinedBodyText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "toggle-section-wrapper",
        // if it's the suggest statuses section and the toggle is checked, don't have margin bottom
        // since the customization area will help push everything down
        xcss: isSuggestStatusesSection && isChecked ? undefined : $23e341bfb9b0a98b$var$toggleSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($23e341bfb9b0a98b$var$HeadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($23e341bfb9b0a98b$var$TitleTextWrapper, null, titleText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $23e341bfb9b0a98b$var$toggleWrapperStyles
    }, isToggleDisabled && disabledTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: disabledTooltip,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $82gXq.default), {
        testId: testId,
        isChecked: isChecked,
        isDisabled: true,
        onChange: onToggleClick
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $82gXq.default), {
        testId: testId,
        isChecked: isChecked,
        onChange: onToggleClick
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($23e341bfb9b0a98b$var$BodyTextWrapper, null, bodyText, isSuggestStatusesSection && setSuggestedStatesArray && isChecked && showRestoreDefaults && originalSuggestedStatesArray ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $200ace427a1c11f6$export$ea56b2bbb6a884a9), {
        spaceKey: spaceKey,
        underlinedBodyText: underlinedBodyText,
        originalSuggestedStatesArray: originalSuggestedStatesArray,
        setSuggestedStatesArray: setSuggestedStatesArray
    }) : null, isSuggestStatusesSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $23e341bfb9b0a98b$var$infoIconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: formatMessage((0, $1jGHE.i18n).moreInfoMessage),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
        color: "var(--ds-icon, #292A2E)",
        label: "info-icon",
        testId: "infoIcon"
    })))));
});
module.exports["ToggleSection"] = $23e341bfb9b0a98b$export$f8b39935006ae1af;

});

parcelRegister("8u6FF", function(module, exports) {

var $frIzR = parcelRequire("frIzR");

/**
 * @generated SignedSource<<a14a8bc4603e47f2ec444ab02e05c8fa>>
 * @relayHash cdfdbe4d4bfab1573c61614ab1550d65
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a0ded532209b4db9bf5ef85efd72ad6977582c78cdef5afec32c9c2fad17faf3
const $d15b30f6fb732dc8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentState"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "stateInput",
                    "variableName": "contentState"
                }
            ],
            "concreteType": "ContentState",
            "kind": "LinkedField",
            "name": "deleteContentState",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "color"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SuggestedContentStateCustomizationAreaDeleteContentStateMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SuggestedContentStateCustomizationAreaDeleteContentStateMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "cdfdbe4d4bfab1573c61614ab1550d65",
            "id": "a0ded532209b4db9bf5ef85efd72ad6977582c78cdef5afec32c9c2fad17faf3",
            "metadata": {},
            "name": "SuggestedContentStateCustomizationAreaDeleteContentStateMutation",
            "operationKind": "mutation",
            "text": "mutation SuggestedContentStateCustomizationAreaDeleteContentStateMutation($contentState:ContentStateInput!){deleteContentState(stateInput:$contentState){name,color,id}}"
        }
    };
}();
$d15b30f6fb732dc8$var$node.hash = "8b6f06ddc6d4f7a1fe5b6c0f41fe87b0";
var $d15b30f6fb732dc8$export$2e2bcd8739ae039 = $d15b30f6fb732dc8$var$node;


/**
 * @generated SignedSource<<b469b252fe8dc4b906dc1a92bad40c08>>
 * @relayHash 21afd2bd4daf123d09dde0f01711592c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 642e553ab83b7c6dea08a11ef5fb8cd3492ed825205e7b7bc2ca2711aae652c9
const $200035e5b99c958a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentState"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentState",
                    "variableName": "contentState"
                }
            ],
            "concreteType": "ContentState",
            "kind": "LinkedField",
            "name": "createSpaceContentState",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "color"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "restrictionLevel"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SuggestedContentStateCustomizationAreaCreateSpaceContentStateMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SuggestedContentStateCustomizationAreaCreateSpaceContentStateMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "21afd2bd4daf123d09dde0f01711592c",
            "id": "642e553ab83b7c6dea08a11ef5fb8cd3492ed825205e7b7bc2ca2711aae652c9",
            "metadata": {},
            "name": "SuggestedContentStateCustomizationAreaCreateSpaceContentStateMutation",
            "operationKind": "mutation",
            "text": "mutation SuggestedContentStateCustomizationAreaCreateSpaceContentStateMutation($contentState:ContentStateInput!){createSpaceContentState(contentState:$contentState){color,name,id,restrictionLevel}}"
        }
    };
}();
$200035e5b99c958a$var$node.hash = "9a2564fc1c158ff5bb9b299dbe25c825";
var $200035e5b99c958a$export$2e2bcd8739ae039 = $200035e5b99c958a$var$node;



var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $9wGTI = parcelRequire("9wGTI");


var $7aRa9 = parcelRequire("7aRa9");


var $308Wd = parcelRequire("308Wd");


var $8miSe = parcelRequire("8miSe");


var $8kr7I = parcelRequire("8kr7I");











var $eEA8O = parcelRequire("eEA8O");


var $lGgRw = parcelRequire("lGgRw");


var $inPa6 = parcelRequire("inPa6");


var $Uu0Pb = parcelRequire("Uu0Pb");














var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");





var $fzqvY = parcelRequire("fzqvY");

var $gQhRa = parcelRequire("gQhRa");

var $fb3kw = parcelRequire("fb3kw");


var $4noo5 = parcelRequire("4noo5");














var $iNJwL = parcelRequire("iNJwL");










var $7sObp = parcelRequire("7sObp");


var $cvXh8 = parcelRequire("cvXh8");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4c73b19e72013c78$var$LargeCircleWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18s816r1 _80omtlke",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4c73b19e72013c78$var$Circle = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_xexnhp": (0, $7sObp.default)(__cmplp.color)
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_2rko1rr0 _11q71cj8 _1bsbqslr _4t3iqslr",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $4c73b19e72013c78$var$CheckIconWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswstnw _4t3iqslr _1bsbqslr _1e0c1txw _1bah1h6o _4cvr1h6o _19pkze3t",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $4c73b19e72013c78$export$83bc3a13193a4818 = (t0)=>{
    const $ = (0, $frIzR.c)(11);
    const { color: color, selectedColor: selectedColor, setSelectedColor: setSelectedColor } = t0;
    let isSelected = false;
    if (color === selectedColor) isSelected = true;
    let t1;
    if ($[0] !== color || $[1] !== setSelectedColor) {
        t1 = ()=>{
            setSelectedColor(color);
        };
        $[0] = color;
        $[1] = setSelectedColor;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== isSelected) {
        t2 = isSelected ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4c73b19e72013c78$var$CheckIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
            label: "check-icon",
            color: "var(--ds-icon-inverse, #FFFFFF)",
            testId: "check-icon"
        })) : null;
        $[3] = isSelected;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== color) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4c73b19e72013c78$var$Circle, {
            color: color,
            "data-testid": "large-color-circle"
        });
        $[5] = color;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t1 || $[8] !== t2 || $[9] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4c73b19e72013c78$var$LargeCircleWrapper, {
            "data-testid": "large-circle-wrapper",
            onClick: t1
        }, t2, t3);
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
};



var $1jGHE = parcelRequire("1jGHE");

const $a6d830ab58d8c249$var$contentStateMakerWrapperStyles = (0, $ecnYn.xcss)({
    padding: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a6d830ab58d8c249$var$CirclesWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _otyru2gc",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $a6d830ab58d8c249$var$ButtonsWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _1bahesu3",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $a6d830ab58d8c249$var$circleAndButtonsWrapperStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.100'
});
const $a6d830ab58d8c249$var$ContentStateMakerComponent = (0, $7aRa9.withFlags)(({ spaceKey: spaceKey, color: color, name: name, closePopup: closePopup, onSave: onSave, flags: flags, intl: { formatMessage: formatMessage } })=>{
    const [selectedColor, setSelectedColor] = (0, $42omo.useState)(color);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const colorsArray = [
        (0, $Uu0Pb.PRIMARY_COLORS).PURPLE,
        (0, $Uu0Pb.PRIMARY_COLORS).BLUE,
        (0, $Uu0Pb.PRIMARY_COLORS).RED,
        (0, $Uu0Pb.PRIMARY_COLORS).YELLOW,
        (0, $Uu0Pb.PRIMARY_COLORS).GREEN
    ];
    const ColorCircles = colorsArray.map((circleColor)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4c73b19e72013c78$export$83bc3a13193a4818), {
            key: circleColor,
            color: circleColor,
            selectedColor: selectedColor,
            setSelectedColor: setSelectedColor
        });
    });
    const handleSubmit = (formState)=>{
        closePopup(); // only save/mutate if the user inputs a status - don't need to check if state has color since default is purple
        if (formState.input) {
            // remove any extra whitespace in string
            const trimmedName = formState.input.replace(/\s+/g, ' ').trim(); // make sure user didn't enter only whitespace
            if (trimmedName) onSave(selectedColor, trimmedName);
            else // user submits all whitespace
            flags.showWarningFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $iNJwL.sharedi18n).emptyStatusFlagTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $iNJwL.sharedi18n).emptyStatusFlagDescription)
            });
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                objectId: spaceKey,
                actionSubjectId: 'adminClickedSaveButton',
                source: 'contentStateAdminSettings'
            }
        }).fire();
    };
    const validateName = (value)=>{
        if (!value) return 'REQUIRED'; // Name input is required
        return undefined;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $a6d830ab58d8c249$var$contentStateMakerWrapperStyles
    }, (0, $9wGTI.fg)('platform-design_system_team-form_conversion') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fzqvY.default), {
        onSubmit: handleSubmit,
        name: "content-state-maker"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
        name: "input",
        defaultValue: name,
        validate: validateName
    }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
            ...fieldProps,
            testId: "text-input",
            autocomplete: "off",
            maxLength: 20,
            placeholder: formatMessage((0, $1jGHE.i18n).addContentStatePlaceholder)
        }), error === 'REQUIRED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gQhRa.ErrorMessage), null, formatMessage((0, $iNJwL.sharedi18n).requiredErrorMessage)), !error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gQhRa.HelperMessage), null, formatMessage((0, $iNJwL.sharedi18n).maxLength)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $a6d830ab58d8c249$var$circleAndButtonsWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a6d830ab58d8c249$var$CirclesWrapper, null, ColorCircles), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a6d830ab58d8c249$var$ButtonsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        testId: "cancel-button",
        appearance: "subtle",
        onClick: closePopup,
        style: {
            marginRight: "var(--ds-space-050, 4px)"
        }
    }, formatMessage((0, $1jGHE.i18n).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
        type: "submit",
        appearance: "primary",
        testId: "save-button"
    }, formatMessage((0, $1jGHE.i18n).save))))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fzqvY.default), {
        onSubmit: handleSubmit
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("form", {
            ...formProps,
            name: "content-state-maker"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fb3kw.default), {
            name: "input",
            defaultValue: name,
            validate: validateName
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4noo5.default), {
                ...fieldProps,
                testId: "text-input",
                autocomplete: "off",
                maxLength: 20,
                placeholder: formatMessage((0, $1jGHE.i18n).addContentStatePlaceholder)
            }), error === 'REQUIRED' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gQhRa.ErrorMessage), null, formatMessage((0, $iNJwL.sharedi18n).requiredErrorMessage)), !error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gQhRa.HelperMessage), null, formatMessage((0, $iNJwL.sharedi18n).maxLength)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $a6d830ab58d8c249$var$circleAndButtonsWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a6d830ab58d8c249$var$CirclesWrapper, null, ColorCircles), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($a6d830ab58d8c249$var$ButtonsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            testId: "cancel-button",
            appearance: "subtle",
            onClick: closePopup,
            style: {
                marginRight: "var(--ds-space-050, 4px)"
            }
        }, formatMessage((0, $1jGHE.i18n).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            type: "submit",
            appearance: "primary",
            testId: "save-button"
        }, formatMessage((0, $1jGHE.i18n).save)))))));
});
const $a6d830ab58d8c249$export$986e9ad250568511 = (0, $aXWIB.injectIntl)($a6d830ab58d8c249$var$ContentStateMakerComponent);





const $a5d5374297d7c873$var$CreateContentStateButtonComponent = (t0)=>{
    const $ = (0, $frIzR.c)(16);
    const { spaceKey: spaceKey, isDisabled: isDisabled, onCreateState: onCreateState, intl: t1 } = t0;
    const { formatMessage: formatMessage } = t1;
    const [isCreateButtonSelected, setIsCreateButtonSelected] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== spaceKey) {
        t2 = ()=>{
            setIsCreateButtonSelected($a5d5374297d7c873$var$_temp);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    objectId: spaceKey,
                    actionSubjectId: "adminCreateStatusButtonClicked",
                    source: "contentStateAdminSettings"
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = spaceKey;
        $[2] = t2;
    } else t2 = $[2];
    const onClick = t2;
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            setIsCreateButtonSelected(false);
        };
        $[3] = t3;
    } else t3 = $[3];
    const closePopup = t3;
    let t4;
    if ($[4] !== onCreateState || $[5] !== spaceKey) {
        t4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6d830ab58d8c249$export$986e9ad250568511), {
                spaceKey: spaceKey,
                closePopup: closePopup,
                color: (0, $Uu0Pb.PRIMARY_COLORS).PURPLE,
                onSave: onCreateState
            });
        $[4] = onCreateState;
        $[5] = spaceKey;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== formatMessage || $[8] !== isCreateButtonSelected || $[9] !== isDisabled || $[10] !== onClick) {
        t5 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                ...triggerProps,
                testId: "create-state-button",
                isSelected: isCreateButtonSelected,
                onClick: onClick,
                style: {
                    marginLeft: "var(--ds-space-100, 8px)",
                    marginTop: "var(--ds-space-100, 8px)",
                    paddingLeft: "var(--ds-space-1000, 80px)",
                    paddingRight: "var(--ds-space-1000, 80px)"
                },
                isDisabled: isDisabled
            }, formatMessage((0, $1jGHE.i18n).createStatus));
        $[7] = formatMessage;
        $[8] = isCreateButtonSelected;
        $[9] = isDisabled;
        $[10] = onClick;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== isCreateButtonSelected || $[13] !== t4 || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            autoFocus: false,
            isOpen: isCreateButtonSelected,
            onClose: closePopup,
            content: t4,
            placement: "right-end",
            trigger: t5
        });
        $[12] = isCreateButtonSelected;
        $[13] = t4;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
};
const $a5d5374297d7c873$export$d946e31893314f11 = (0, $aXWIB.injectIntl)($a5d5374297d7c873$var$CreateContentStateButtonComponent);
function $a5d5374297d7c873$var$_temp(prevIsCreateButtonSelected) {
    return !prevIsCreateButtonSelected;
}


const $0d1abdf80e8c1a61$export$ccc9fe24e363c71e = (color, name, array)=>{
    // toLowerCase the color since BE stores colors with lowercase letters
    const lowerCaseColor = color.toLowerCase();
    const duplicate = array.filter((status)=>status?.color === lowerCaseColor && status?.name === name);
    return duplicate.length === 1;
};





const $4a58c2e437513edb$var$MAX_SUGGESTED_STATES_DEFAULT = 5;
const $4a58c2e437513edb$var$MAX_SUGGESTED_STATES_EXPANDED = 10; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4a58c2e437513edb$var$SuggestedContentStateCustomizationAreaWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_otyr1jfw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $4a58c2e437513edb$export$3f025cf996f190f6 = (0, $7aRa9.withFlags)(({ spaceKey: spaceKey, showSuggested: showSuggested, suggestedStatesArray: suggestedStatesArray, setSuggestedStatesArray: setSuggestedStatesArray, additionalRows: additionalRows, flags: flags })=>{
    const maxSuggestedStates = (0, $9wGTI.fg)('cc-increase-content-states') ? $4a58c2e437513edb$var$MAX_SUGGESTED_STATES_EXPANDED : $4a58c2e437513edb$var$MAX_SUGGESTED_STATES_DEFAULT;
    const [createNewContentStateMutation] = (0, $308Wd.useMutationInterop)((0, $200035e5b99c958a$export$2e2bcd8739ae039), {
        onCompleted: (data)=>{
            // Doing another setState after the mutation is completed so we can store the status ID.
            // Since the ID is generated in the backend, we didn't have an ID and therefore couldn't store it in the
            // initial set state in handleStateCreation() since we created a new status.
            const newState = data.createSpaceContentState ?? null;
            const copyOfArrayWithoutLastItem = [
                ...suggestedStatesArray
            ];
            copyOfArrayWithoutLastItem.pop();
            const newArray = [
                ...copyOfArrayWithoutLastItem.filter((item)=>item !== undefined),
                newState
            ];
            setSuggestedStatesArray(newArray);
        },
        __callerPackage__: "@confluence/content-state"
    });
    const [deleteSpaceContentStateMutation] = (0, $308Wd.useMutationInterop)((0, $d15b30f6fb732dc8$export$2e2bcd8739ae039), {
        __callerPackage__: "@confluence/content-state"
    });
    const removeState = (color, name, id)=>{
        if (color && name && id) {
            deleteSpaceContentStateMutation({
                variables: {
                    contentState: {
                        spaceKey: spaceKey,
                        color: color,
                        name: name,
                        id: id // FIXME this problem always existed added typecasting as a part of codemods
                    }
                }
            }); // newArray is the original array with the removed page status filtered out
            const newArray = [];
            for (const state of suggestedStatesArray)if (state?.color !== color || state?.name !== name) newArray.push(state);
            setSuggestedStatesArray(newArray);
        }
    };
    const handleStateCreation = (color, name)=>{
        const newState = {
            color: color,
            name: name
        }; // only add to array if it is not a duplicate of another name
        if (!(0, $0d1abdf80e8c1a61$export$ccc9fe24e363c71e)(color, name, suggestedStatesArray)) {
            createNewContentStateMutation({
                variables: {
                    contentState: {
                        ...newState,
                        color: (0, $8miSe.tokenToHex)(color),
                        spaceKey: spaceKey
                    }
                }
            });
            const newArray = [
                ...suggestedStatesArray,
                newState
            ];
            setSuggestedStatesArray(newArray);
        } else // if duplicate status was added, show a flag warning user
        flags.showWarningFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $1jGHE.i18n).flagTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), (0, $1jGHE.i18n).flagDescription)
        });
    };
    // Build the merged list: additionalRows are partitioned once and inserted
    // at the correct position (before the first restricted state, or at the end).
    const rows = additionalRows ?? [];
    const prefixNodes = [];
    const suffixNodes = [];
    for (const row of rows){
        const node = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
            key: row.key
        }, row.node);
        if (row.insertBeforeRestrictedState) prefixNodes.push(node);
        else suffixNodes.push(node);
    }
    const stateRows = [];
    let insertedPrefix = false;
    for (const state of suggestedStatesArray){
        if (!insertedPrefix && state?.restrictionLevel && state.restrictionLevel !== 'NONE') {
            stateRows.push(...prefixNodes);
            insertedPrefix = true;
        }
        if (state) stateRows.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8kr7I.SuggestedContentState // @ts-ignore
        ), {
            key: state.color + state.name,
            color: state.color,
            spaceKey: spaceKey,
            name: state.name,
            restrictionLevel: state.restrictionLevel,
            id: state.id,
            removeState: removeState
        }));
    }
    if (!insertedPrefix) stateRows.push(...prefixNodes);
    stateRows.push(...suffixNodes);
    return showSuggested && suggestedStatesArray.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4a58c2e437513edb$var$SuggestedContentStateCustomizationAreaWrapper, {
        "data-testid": "suggested-state-area-wrapper"
    }, stateRows, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a5d5374297d7c873$export$d946e31893314f11), {
        spaceKey: spaceKey,
        onCreateState: handleStateCreation,
        isDisabled: suggestedStatesArray.length === maxSuggestedStates
    })) : null;
});
module.exports["SuggestedContentStateCustomizationArea"] = $4a58c2e437513edb$export$3f025cf996f190f6;

});

parcelRegister("8kr7I", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $1Whri = parcelRequire("1Whri");


var $5nBzc = parcelRequire("5nBzc");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $4S6vT = parcelRequire("4S6vT");








var $gMc0m = parcelRequire("gMc0m");





var $inPa6 = parcelRequire("inPa6");


var $gKvd9 = parcelRequire("gKvd9");


var $3gadb = parcelRequire("3gadb");


var $1jGHE = parcelRequire("1jGHE");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f48e516834918f55$var$TrashButtonWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1bsb7vkz _4t3i7vkz _80omtlke",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f48e516834918f55$var$TrashButtonComponent = (t0)=>{
    const $ = (0, $frIzR.c)(23);
    const { spaceKey: spaceKey, color: color, name: name, id: id, setIsTrashHovered: setIsTrashHovered, removeState: removeState, intl: t1 } = t0;
    const { formatMessage: formatMessage } = t1;
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t2;
    if ($[0] !== setIsTrashHovered) {
        t2 = ()=>{
            setIsHovered(true);
            setIsTrashHovered(true);
        };
        $[0] = setIsTrashHovered;
        $[1] = t2;
    } else t2 = $[1];
    const onHover = t2;
    let t3;
    if ($[2] !== setIsTrashHovered) {
        t3 = ()=>{
            setIsHovered(false);
            setIsTrashHovered(false);
        };
        $[2] = setIsTrashHovered;
        $[3] = t3;
    } else t3 = $[3];
    const onLeave = t3;
    let t4;
    if ($[4] !== color || $[5] !== createAnalyticsEvent || $[6] !== id || $[7] !== name || $[8] !== removeState || $[9] !== spaceKey) {
        t4 = ()=>{
            removeState(color || "", name || "", id || "");
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    objectId: spaceKey,
                    actionSubjectId: "adminRemovedContentState",
                    source: "contentStateAdminSettings"
                }
            }).fire();
        };
        $[4] = color;
        $[5] = createAnalyticsEvent;
        $[6] = id;
        $[7] = name;
        $[8] = removeState;
        $[9] = spaceKey;
        $[10] = t4;
    } else t4 = $[10];
    const onClick = t4;
    let t5;
    if ($[11] !== formatMessage) {
        t5 = formatMessage((0, $1jGHE.i18n).remove);
        $[11] = formatMessage;
        $[12] = t5;
    } else t5 = $[12];
    const t6 = isHovered ? "var(--ds-icon-danger, #C9372C)" : "var(--ds-icon-subtle, #505258)";
    let t7;
    if ($[13] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gKvd9))), {
            label: "remove-icon",
            color: t6
        });
        $[13] = t6;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== onClick || $[16] !== onHover || $[17] !== onLeave || $[18] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f48e516834918f55$var$TrashButtonWrapper, {
            "data-testid": "trash-button-wrapper",
            onMouseOver: onHover,
            onMouseOut: onLeave,
            onClick: onClick
        }, t7);
        $[15] = onClick;
        $[16] = onHover;
        $[17] = onLeave;
        $[18] = t7;
        $[19] = t8;
    } else t8 = $[19];
    let t9;
    if ($[20] !== t5 || $[21] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t5,
            position: "top"
        }, t8);
        $[20] = t5;
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    return t9;
};
const $f48e516834918f55$export$2d02bf734038 = (0, $aXWIB.injectIntl)($f48e516834918f55$var$TrashButtonComponent);


const $2717b2ef84525114$var$i18n = (0, $aXWIB.defineMessages)({
    betaTag: {
        id: "content-state.space-admin.suggested-content-state.beta-tag",
        defaultMessage: "Beta"
    }
});
const $2717b2ef84525114$var$wrapperStyles = {
    root: "_2rko12b0 _1rjc12x7 _18zru2gc _1e0c1txw _4t3i1qjk _1bsbz5qo _4cvr1h6o",
    trashHovered: "_bfhk1gly _1qu2nqa1 _12y3e4h9 _12ji1bqt"
};
const $2717b2ef84525114$var$stateAndButtonsStyles = {
    root: "_1e0c1txw _1bsb1osq _1bah1yb4 _4cvr1h6o"
};
const $2717b2ef84525114$var$iconStyles = {
    root: "_1e0c1txw _4cvr1h6o _12l2pxbi"
};
const $2717b2ef84525114$export$507f7289dac71629 = (t0)=>{
    const $ = (0, $frIzR.c)(26);
    const { spaceKey: spaceKey, name: name, color: color, restrictionLevel: restrictionLevel, id: id, removeState: removeState, hideTrash: hideTrash, icon: Icon, iconColor: iconColor, showBetaTag: showBetaTag } = t0;
    const [isTrashHovered, setIsTrashHovered] = (0, $42omo.useState)(false);
    const resolvedIconColor = iconColor || "var(--ds-icon-accent-blue, #357DE8)";
    const t1 = isTrashHovered && $2717b2ef84525114$var$wrapperStyles.trashHovered;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $1Whri.cx)($2717b2ef84525114$var$wrapperStyles.root, t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== Icon || $[3] !== color || $[4] !== resolvedIconColor || $[5] !== restrictionLevel) {
        t3 = Icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $2717b2ef84525114$var$iconStyles.root
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Icon, {
            label: "",
            size: "medium",
            color: resolvedIconColor
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4S6vT.ContentStateColor), {
            appearance: "spaceAdminContentState",
            color: color,
            restrictionLevel: restrictionLevel
        });
        $[2] = Icon;
        $[3] = color;
        $[4] = resolvedIconColor;
        $[5] = restrictionLevel;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== showBetaTag) {
        t4 = showBetaTag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
            appearance: "discovery"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), $2717b2ef84525114$var$i18n.betaTag));
        $[7] = showBetaTag;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== name || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.100"
        }, name, t4);
        $[9] = name;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== color || $[13] !== hideTrash || $[14] !== id || $[15] !== name || $[16] !== removeState || $[17] !== spaceKey) {
        t6 = !hideTrash && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f48e516834918f55$export$2d02bf734038), {
            spaceKey: spaceKey,
            name: name,
            color: color,
            id: id,
            setIsTrashHovered: setIsTrashHovered,
            removeState: removeState
        });
        $[12] = color;
        $[13] = hideTrash;
        $[14] = id;
        $[15] = name;
        $[16] = removeState;
        $[17] = spaceKey;
        $[18] = t6;
    } else t6 = $[18];
    let t7;
    if ($[19] !== t5 || $[20] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            testId: "text-and-buttons-wrapper",
            xcss: $2717b2ef84525114$var$stateAndButtonsStyles.root
        }, t5, t6);
        $[19] = t5;
        $[20] = t6;
        $[21] = t7;
    } else t7 = $[21];
    let t8;
    if ($[22] !== t2 || $[23] !== t3 || $[24] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            testId: "suggested-state-wrapper",
            xcss: t2
        }, t3, t7);
        $[22] = t2;
        $[23] = t3;
        $[24] = t7;
        $[25] = t8;
    } else t8 = $[25];
    return t8;
};
module.exports["SuggestedContentState"] = $2717b2ef84525114$export$507f7289dac71629;

});


//# sourceMappingURL=SpaceAdminConfig.7cef40b3.js.map
